export const LANGUAGES = ["en", "fr", "es", "cn"] as const;

export type Language = (typeof LANGUAGES)[number];
